export default __webpack_public_path__ + "static/media/PrintGrey.0259186b.svg";